export default "__VITE_ASSET__BfhOkQma__"